import { ReactElement } from 'react'
import { useParams } from 'react-router-dom'
import { AxiosError } from 'axios'
import { Stack } from '@mui/material'
import { useResultsInvalidation } from '@editor/hooks'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AddButton } from '@ui/actions'
import { useSnackbar } from '@ui/snackbar'
import { getModel } from '@queries'
import { buildErrorMessage } from 'src/constants/errors'
import { addRoof } from 'src/state/mutations/model'

const AddRoofForm = (): ReactElement => {
  const { enqueueSnackbar } = useSnackbar()
  const { projectId }: { projectId?: string } = useParams()
  const invalidateResults = useResultsInvalidation()
  const queryClient = useQueryClient()

  const { mutate: createNewRoofSlab, isLoading: isCreatingNewRoofSlab } = useMutation(
    () => {
      return addRoof.request(projectId as string)
    },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(getModel.getKey(projectId))

        invalidateResults(projectId as string)
        enqueueSnackbar('Dachfläche erfolgreich hinzugefügt', { variant: 'success' })
      },
      onError: (error: AxiosError) => {
        enqueueSnackbar(buildErrorMessage(error, 'Fehler beim hinzufügen der Dachfläche'), {
          variant: 'error',
        })
      },
    },
  )

  return (
    <Stack direction="row" justifyContent="end" spacing={1} mt={1}>
      <AddButton
        variant="contained"
        loading={isCreatingNewRoofSlab}
        onClick={() => createNewRoofSlab()}
        fullWidth
        disabled={false}
        data-cy="btn-submit-create-new-roof-slab"
      >
        Neue Dachfläche anlegen
      </AddButton>
    </Stack>
  )
}

export default AddRoofForm
